import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import { PLAN_ACTIVE } from '@disco/constants/FeatureTypes'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { makeIsFeatureEnabled } from '@disco/state-management/selectors/business'
import {
  getNumberOfUsers,
  getUser,
} from '@disco/state-management/selectors/user'

import type { User } from 'types/user'

import Pricing2021 from 'components/common/pricing2021'
import Heading from 'components/ui/heading'
import Spinner from 'components/ui/spinner'
import { pricingModalStyles } from 'components/utils/modalStyles'

const mapStateToProps = state => {
  const isFeatureEnabled = makeIsFeatureEnabled()
  const activePlan = isFeatureEnabled(state, {
    featureName: PLAN_ACTIVE,
  })
  const user = getUser(state)
  return {
    deprecatedPlan: !activePlan,

    /* TODO: refactoring:
      maxFilesCurrentPlan is the code from the old Pricing component.
      Previously, maxFilesCurrentPlan was used in the plan upgrade/downgrade logic.
      Currently Pricing component does not include the upgrade/downgrade plan flow
      asana task: https://app.asana.com/0/0/1201426247015104/f
    */
    maxFilesCurrentPlan: user.business.stats.total_track_count,

    /* TODO: refactoring:
      maxUsersCurrentPlan is the code from the old Pricing component.
      Previously, maxUsersCurrentPlan was used in the plan upgrade/downgrade logic.
      Currently Pricing component does not include the upgrade/downgrade plan flow
      asana task: https://app.asana.com/0/0/1201426247015104/f
    */
    maxUsersCurrentPlan: getNumberOfUsers(state),
    userData: user,
    planUpdateLoad: state.user.planUpdateLoad,
  }
}

const mapDispatchToProps = {
  sendMixpanelEvent,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  onClose?: (...args: Array<any>) => any
  title?: string
  navigate: NavigateFunction
  showBillingSummary?: boolean
}

class PricingModal extends React.Component<Props> {
  static defaultProps = {
    title: 'Choose the DISCO plan that’s right for you',
  }
  billingRef = React.createRef<HTMLDivElement>()

  onClose = () => {}

  componentDidUpdate(prevProps) {
    if (prevProps.planUpdateLoad && !this.props.planUpdateLoad) {
      this.props.navigate('/')
    }
  }

  render() {
    const {
      deprecatedPlan,
      maxFilesCurrentPlan,
      maxUsersCurrentPlan,
      userData,
      planUpdateLoad,
      showBillingSummary,
    } = this.props

    if (planUpdateLoad) {
      return <Spinner />
    }

    return (
      <Modal
        isOpen
        style={pricingModalStyles}
        onRequestClose={this.props.onClose || this.onClose}
      >
        <Theme>
          <Heading size={600}>{this.props.title}</Heading>
          <div className="Billing_Pricing2021Container">
            <div
              className="Billing_Pricing2021FlexWrapper"
              ref={this.billingRef}
            >
              <Pricing2021
                billingRef={this.billingRef}
                onPlanSelect={this.props.onClose}
                deprecatedPlan={deprecatedPlan}
                maxFilesCurrentPlan={maxFilesCurrentPlan}
                maxUsersCurrentPlan={maxUsersCurrentPlan}
                rootPath="/pricing"
                showBillingSummary={showBillingSummary}
              />
            </div>
          </div>
        </Theme>
      </Modal>
    )
  }
}

const ConnectedPricingModal = connector(PricingModal)

function PricingModalWithNavigate(props) {
  const navigate = useNavigate()
  return <ConnectedPricingModal {...props} navigate={navigate} />
}

export default PricingModalWithNavigate
